<style scoped>
.product {
  padding: 0 !important;
}

.product-image-area {
  overflow: hidden;
  position: relative;
  padding: 0 !important;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px !important;
}

.new-faixa {
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  padding: 4px 8px;
}

.new-faixa div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.maior-lance {
  position: relative;
  width: 100%;
  z-index: 99;
}

.product .product-image-area .product-image {
  border-radius: 0 !important;
}

#portotemplate .product .product-name a:focus,
#portotemplate .product .product-name a:hover {
  color: #032c35 !important;
  text-decoration: none;
  font-weight: 600 !important;
}

.maior-lance .new {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-direction: column;
}

.maior-lance span {
  font-size: 24px !important;
  line-height: 15px;
  background: #032c35bd;
  border-radius: 0 0 5px 5px;
  padding: 7px 10px 12px;
  color: #fff;
  margin-top: -1px;
  width: 100% !important;;
}

.maior-lance small {
  font-size: 45% !important;
  display: inline-block;
  margin-top: 4px;
}

.maior-lance strong {
  margin-right: -8px;
  margin-top: -12px;
}

.product-details-area {
  padding: 4px !important;
  margin: 0px !important;
}

.product-name {
  margin: 2px !important;
}

h2.product-name {
  max-height: 35px;
  min-height: 35px;
  overflow: auto;
}

.product-ratings {
  margin: 0 0 4px 0 !important;
}

.product-ratings a {
  color: #032c35 !important;
}

.faixa_avaliacao {
  background: #032c35;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  color: #FFF;
  padding: 0 4px;
}

.product-info {
  padding: 10px 0 0 0 !important;
  border: none;
  background: transparent;
}

.container_lance {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container_lance span {
  font-size: 13px;
  font-weight: 500;
}

.container_lance button span {
  font-size: 22px;
  font-weight: 600;
}

.container_lance button {
  width: 80%;
  border-radius: 6px;
  border: 0;
  padding: 8px 0px 6px 0px;
  cursor: no-drop;
  color: #333 !important;
  background: #f7f7f7;
}

.container_lance .active {
  background: #032c35 !important;
  color: #FFF !important;
  cursor: pointer;
}

.habilitacao {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  justify-content: center;
  text-align: center;
  font-weight: 600;
  font-size: small;
  width: 100%;
  margin-top: -2.4rem;
  color: #3f3f3f;
  background: hsl(0deg 0% 90.2% / 80%);
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  transition: 0.3s;
  animation: efeitoTransitionHabilitacao;
  z-index: 99;
}

.habilitacao:hover {
  transition: 0.3s;
  height: 66%;
  margin-top: -19.5rem;
  flex-direction: column;
  font-size: 18px;
}

.habilitacao img {
  margin-right: 5px;
}

.habilitacao:hover img {
  margin-right: 5px;
  width: 29px;
  margin-bottom: 10px;
}

.count-lances {
  position: absolute;
  left: 10px;
}

@keyframes efeitoTransitionHabilitacao {
  0% {
    opacity: 0.3;
  }

  50% {
    height: 33%;
    opacity: 0.6;
  }

  100% {
    height: 66%;
    opacity: 1;
  }
}

.add-favorito {
  font-size: 18px;
  top: 43px;
  right: 14px;
  border-radius: 0;
  padding: 0;
  background: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  z-index: 99;
  color: #ba0000 !important;
}

#portotemplate .rounded {
  border-radius: 0 !important;
}

.dialog-content {
  max-height: 406px !important;
}
</style>
<template>
  <div class="product">
    <div v-show="loading" style="min-height:480px;padding: 50% 0;">
      <Stretch>Carregando...</Stretch>
    </div>
    <div style="padding: 4px" v-show="loading == false">
      <ModalHAbilitacaoExtra @fechaModalLiberacaoExtra="fechaModalLiberacaoExtra" :info="info"
                             :abre-fecha="abreModal"/>
      <div v-if="usuarioid" class="add-favorito" :title="favoritoTitle" v-show="statusleilao_id != 17">
        <span :class="`fa ${isLoteFavorito(dados.lote_id) ? 'fa-heart' : 'fa-heart-o'}`" @click="addFavorito"></span>
      </div>
      <figure class="product-image-area">
        <!--  -->
        <div class="new-faixa" :style="'background: ' + dados.statusLoteBg + '; opacity:0.7;'">
          <div v-if="statusleilao_id == 17">
            <span class="lote-id-faixa">Rodada</span>
            <span>{{ dados.nu }}</span>
          </div>
          <div v-else>
            <span class="lote-id-faixa">{{ dados.nu }}</span>
            <span>{{ dados.statuslote }}</span>
          </div>
        </div>
        <!--  -->
        <div v-if="statusleilao_id != 17">
          <router-link @click.native="loteClicado"
                       :to="`/leilao/index/leilao_id/${dados.leilao_id}/lote/${dados.lote_id}`"
                       class="open-lote product-image">
            <div>
              <div v-if="dados.fotos && dados.fotos[0]">
                <carousel :perPage="1" :navigationEnabled="true" :paginationEnabled="false" :autoplay="false">
                  <slide v-for="(img, idx) in dados.fotos" :key="idx">
                    <img class="img-fluid rounded" alt="lote imagem" :src="img.nm_path_completo"/>
                  </slide>
                </carousel>
              </div>
              <div v-else>
                <img class="img-fluid rounded" alt="lote imagem"
                     src="https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/fotos/nao-disponivel.jpg"/>
              </div>
            </div>
          </router-link>
        </div>
        <div v-else>
          <div :style="'margin-top: 35px;'"></div>
        </div>
        <div id="habilitacao" class="habilitacao" v-for="(vistoria, id) in dados.vistoria" :key="id"
             v-show="vistoria.usuariovistorialotexstatusliberacaoextra != undefined"
             @click.prevent="liberacaoExtraMsg(vistoria.usuariovistorialotexstatusliberacaoextra), abreModal = !abreModal"
             title="requer habilitação especial neste lote, clique aqui para saber mais.">
          <img src="../../assets/portotemplate/img/fechadura.png" alt="fechadura de bloqueio habilitação especial">
          Requer habilitação especial
        </div>
        <!--  -->
        <div v-if="dados && dados.vl_lance !== ''" class="maior-lance">
          <span class="new" style="text-align:right;">
            <div>
              <small style="float: left; margin: 4px 0;">
                {{ dados.nm_usuario ? "Usuário: " + dados.nm_usuario : "" }}
              </small>
              <small v-if="statusleilao_id != 17" style="margin-right: -5px;">Valor atual</small>
              <small v-else style="margin-right: -5px;">Desconto</small>
            </div>
            <br/>
            <div v-if="statusleilao_id != 17">
              <small class="count-lances">Lances: {{ dados.count_lances || 0 }}</small>
              <strong>{{ dados.vl_lance }}</strong>
            </div>
            <div v-else>
              <strong style="display: inline-block;">{{
                  dados.vl_lance.replace("R$ ", "").replace(",00", "").replace(".00", "")
                }} %</strong>
            </div>
          </span>
        </div>
        <div v-else class="maior-lance">
          <span class="new" style="text-align:right;" v-show="statusleilao_id != 17">
            <small style="margin-right: -5px;">Valor inicial</small>
            <br/>
            <strong style="display: inline-block;">{{ dados.vl_lanceinicial }}</strong>
          </span>
        </div>
      </figure>
    </div>

    <div v-show="loading == false" class="product-details-area">
      <h2 class="product-name" v-show="statusleilao_id != 17">
        <router-link @click.native="loteClicado"
                     :to="`/leilao/index/leilao_id/${dados.leilao_id}/lote/${dados.lote_id}`" class="open-lote"
                     v-html="dados.nm_titulo"></router-link>
      </h2>

      <div class="product-ratings" v-show="statusleilao_id != 17">
        <router-link @click.native="loteClicado"
                     :to="`/leilao/index/leilao_id/${dados.leilao_id}/lote/${dados.lote_id}`">clique e saiba
          mais
        </router-link>
      </div>
    </div>

    <div v-show="loading == false" class="faixa_avaliacao">
      <span>Valor da Avaliação: R$ {{
          parseFloat(dados.vl_lanceminimo)
            .toFixed(2).replace('.', ',')
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        }}</span>
    </div>

    <div v-show="loading == false" v-if="statusleilao_id != 13 && statusleilao_id != 17" style="margin-bottom: 2px;">
      <div class="container_lance"
           v-if="dados.statuslote == 'Vendido' || (statusleilao_id == 1 || statusleilao_id == 5 || statusleilao_id == 8)">

        <template
          v-if="![4].includes(leilao.statustipoleilao_id) && leilao.dt_segundoleilao_data !== null && leilao.dt_segundoleilao_hora !== null && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'">
          <span>{{
              (statusleilao_id != 1 && statusleilao_id != 5 && statusleilao_id != 8) ? `Enviar lance
            ${this.nu_primeira_data}° Leilão` : `Lance Inicial ${this.nu_primeira_data}° Leilão`
            }}</span>
        </template>
        <template v-else>
          <span>{{
              (statusleilao_id != 1 && statusleilao_id != 5 && statusleilao_id != 8) ? 'Enviar lance' : 'Lance Inicial'
            }}</span>
        </template>
        <button :dataloteid="dados.lote_id"
                :datavalor="(!leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : false" :disabled="true"
                :class="(!leilao.leilao_id_primeiroleilao ? 'lance_inicial active' : 'lance_inicial')"
                :title="'Enviar lance'"
                style="margin-top: 0px;">
          <span>{{
              (leilao.leilao_id_primeiroleilao) ? dados.primeiro_vistoria_vl_lanceinicial : dados.vl_lance_sugerido
            }}</span>
        </button>

        <template
          v-if="![4].includes(leilao.statustipoleilao_id) && leilao.dt_segundoleilao_data !== null && leilao.dt_segundoleilao_hora !== null && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'">
          <span>{{
              (statusleilao_id != 1 && statusleilao_id != 5 && statusleilao_id != 8) ? `Enviar lance
            ${this.nu_segunda_data}° Leilão` : `Lance Inicial ${this.nu_segunda_data}° Leilão`
            }}</span>
          <button :dataloteid="dados.lote_id"
                  :datavalor="(!leilao.leilao_id_primeiroleilao) ? false : dados.vl_lance_sugerido" :disabled="true"
                  :class="(!leilao.leilao_id_primeiroleilao ? 'lance_inicial' : 'lance_inicial active')"
                  :title="'Enviar lance'" style="margin-top: 0px;">
            <span>{{
                (leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : dados.vistoria_vl_lanceinicialsegundoleilao
              }}</span>
          </button>
        </template>

      </div>
      <div class="container_lance" v-else>
        <template
          v-if="![4].includes(leilao.statustipoleilao_id) && leilao.dt_segundoleilao_data !== null && leilao.dt_segundoleilao_hora !== null">
          <span>{{
              (statusleilao_id != 1 && statusleilao_id != 5 && statusleilao_id != 8) ? `Enviar lance
            ${this.nu_primeira_data}° Leilão` : `Lance Inicial ${this.nu_primeira_data}° Leilão`
            }}</span>
        </template>
        <template v-else>
          <span>{{
              (statusleilao_id != 1 && statusleilao_id != 5 && statusleilao_id != 8) ? 'Enviar lance' : 'Lance Inicial'
            }}</span>
        </template>
        <button @click="enviarLance" :dataloteid="dados.lote_id" :datavalor="(!leilao.leilao_id_primeiroleilao)
          ? dados.vl_lance_sugerido
          : false" :disabled="(!liberado || !dados.liberado) && leilao.leilao_id_primeiroleilao" :class="(!leilao.leilao_id_primeiroleilao)
            ? 'lance_inicial active'
            : 'lance_inicial'" :title="'Enviar lance'" style="margin-top: 0px;">
          <span>{{
              (leilao.leilao_id_primeiroleilao) ? (dados.primeiro_vistoria_vl_lanceinicial ?
                dados.primeiro_vistoria_vl_lanceinicial : '--') : dados.vl_lance_sugerido
            }}</span>
        </button>
        <template
          v-if="![4].includes(leilao.statustipoleilao_id) && leilao.dt_segundoleilao_data !== null && leilao.dt_segundoleilao_hora !== null">
          <span>{{
              (statusleilao_id != 1 && statusleilao_id != 5 && statusleilao_id != 8) ? `Enviar lance
            ${this.nu_segunda_data}º Leilão` : `Lance inicial ${this.nu_segunda_data}° Leilão`
            }}</span>
          <button @click="enviarLance" :dataloteid="dados.lote_id"
                  :datavalor="(!leilao.leilao_id_primeiroleilao) ? false : dados.vl_lance_sugerido"
                  :disabled="(!liberado || !dados.liberado) && leilao.leilao_id_primeiroleilao"
                  :class="(!leilao.leilao_id_primeiroleilao ? 'lance_inicial' : 'lance_inicial active')"
                  :title="'Enviar lance'" style="margin-top: 0px;">
            <span>{{
                (leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : dados.vistoria_vl_lanceinicialsegundoleilao
              }}</span>
          </button>
        </template>
      </div>
      <div class="product-info">
        <Countdown :deadline="dt_fechamento_lote" :statusleilao_id="statusleilao_id"
                   :statuslote_id="dados.statuslote"/>
      </div>
    </div>
    <div v-show="loading == false" v-else-if="statusleilao_id != 17">
      <div class="container_lance"
           v-if="dados.statuslote == 'Vendido' || (statusleilao_id == 1 || statusleilao_id == 5 || statusleilao_id == 8)">

        <template
          v-if="![4].includes(leilao.statustipoleilao_id) && leilao.dt_segundoleilao_data !== null && leilao.dt_segundoleilao_hora !== null && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'">
          <span class="lance-label">Venda Direta {{ this.nu_primeira_data }}° Leilão</span>
        </template>
        <template v-else>
          <span class="lance-label">Venda Direta</span>
        </template>
        <button :dataloteid="dados.lote_id"
                :datavalor="(!leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : false" :disabled="true"
                :class="(!leilao.leilao_id_primeiroleilao ? 'lance_inicial active' : 'lance_inicial')" :title="!liberado || !dados.liberado
            ? 'Necessita de permissões'
            : 'Enviar lance'" style="margin-top: 0px;">
          <span>{{
              (leilao.leilao_id_primeiroleilao) ? dados.primeiro_vistoria_vl_lanceinicial : dados.vl_lance_sugerido
            }}</span>
        </button>

        <template
          v-if="![4].includes(leilao.statustipoleilao_id) && leilao.dt_segundoleilao_data !== null && leilao.dt_segundoleilao_hora !== null && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'">
          <span class="lance-label">Venda Direta {{ this.nu_segunda_data }}° Leilão</span>
          <button :dataloteid="dados.lote_id"
                  :datavalor="(!leilao.leilao_id_primeiroleilao) ? false : dados.vl_lance_sugerido" :disabled="true"
                  :class="(!leilao.leilao_id_primeiroleilao ? 'lance_inicial' : 'lance_inicial active')" :title="!liberado || !dados.liberado
              ? 'Necessita de permissões'
              : 'Enviar lance'" style="margin-top: 0px;">
            <span>{{
                (leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : dados.vistoria_vl_lanceinicialsegundoleilao
              }}</span>
          </button>
        </template>
      </div>
      <div class="container_lance" v-else>
        <template
          v-if="![4].includes(leilao.statustipoleilao_id) && leilao.dt_segundoleilao_data !== null && leilao.dt_segundoleilao_hora !== null && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'">
          <span class="lance-label">Venda Direta {{ this.nu_primeira_data }}° Leilão</span>
        </template>
        <template v-else>
          <span class="lance-label">Venda Direta</span>
        </template>
        <button @click="enviarVendadireta" :dataloteid="dados.lote_id"
                :datavalor="(!leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : false"
                :disabled="(!liberado || !dados.liberado) && leilao.leilao_id_primeiroleilao"
                :class="(!leilao.leilao_id_primeiroleilao ? 'lance_inicial active' : 'lance_inicial')" :title="!liberado || !dados.liberado
            ? 'Necessita de permissões'
            : 'Enviar lance'" style="margin-top: 0px;">
          <span>{{
              (leilao.leilao_id_primeiroleilao) ? dados.primeiro_vistoria_vl_lanceinicial : dados.vl_lance_sugerido
            }}</span>
        </button>

        <template
          v-if="![4].includes(leilao.statustipoleilao_id) && leilao.dt_segundoleilao_data !== null && leilao.dt_segundoleilao_hora !== null && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'">
          <span class="lance-label">Venda Direta {{ this.nu_segunda_data }}° Leilão</span>
          <button @click="enviarVendadireta" :dataloteid="dados.lote_id"
                  :datavalor="(!leilao.leilao_id_primeiroleilao) ? false : dados.vl_lance_sugerido"
                  :disabled="(!liberado || !dados.liberado) && leilao.leilao_id_primeiroleilao"
                  :class="(!leilao.leilao_id_primeiroleilao ? 'lance_inicial' : 'lance_inicial active')" :title="!liberado || !dados.liberado
              ? 'Necessita de permissões'
              : 'Enviar lance'" style="margin-top: 0px;">
            <span>{{
                (leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : dados.vistoria_vl_lanceinicialsegundoleilao
              }}</span>
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Countdown from '@/components/shared/Countdown.vue'
import Carousel from '@/components/customCarousel/Carousel'
import Slide from '@/components/customCarousel/Slide'
import {Circle6, Stretch} from 'vue-loading-spinner'
import ModalHAbilitacaoExtra from "./ModalHAbilitacaoExtra.vue";

export default {
  name: 'Card',
  components: {
    ModalHAbilitacaoExtra,
    Countdown,
    Carousel,
    Stretch,
    Circle6,
    Slide
  },

  props: [
    'leilao',
    'dadosLeilao',
    'dados',
    'liberado',
    'usuarioid',
    'isfavorito',
    'statusleilao_id',
    'intermediarios',
    'paramsite_proposta',
    'time'
  ],

  data() {
    return {
      errors: [],
      loading: true,
      pathName: location.protocol + '//' + window.HOSTNAME,
      widthCarousel: 235,
      vl_avaliacaocredito: '-',
      liberacaoStatus: false,
      money: {
        decimal: '',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false,
        min: 0,
        max: 100
      },
      abreModal: false,
      info: '',
      nu_primeira_data: 1,
      nu_segunda_data: 2,
      interesse: [],
      dt_fechamento_lote: 0
    }
  },
  mounted() {
    const self = this;
    if (self.leilao) {

      if (self.leilao.datas && Array.isArray(self.leilao.datas)) {
        self.leilao.datas.sort((a, b) => new Date(a.dt) - new Date(b.dt));

        for (const i in self.leilao.datas) {
          const dateObject = new Date(self.leilao.datas[i].dt);
          const year = dateObject.getFullYear().toString().padStart(2, '0');
          const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
          const day = dateObject.getDate().toString().padStart(2, '0');
          const hours = dateObject.getHours().toString().padStart(2, '0');
          var minutes = dateObject.getUTCMinutes().toString().padStart(2, '0');

          const data_array = `${day}/${month}/${year}`;
          const hora_array = `${hours}:${minutes}`;
          const posicao = parseInt(i) + 1;

          if (self.leilao.dt_formatada == data_array && self.leilao.hr_formatada == hora_array) {
            this.nu_primeira_data = posicao
          }

          if (self.leilao.dt_segundoleilao_data == data_array && self.leilao.dt_segundoleilao_hora == hora_array) {
            this.nu_segunda_data = posicao
          }
        }
      }
    }
  },
  created() {
    this.refreshLote()
    const self = this

    this.firebase_db.ref(
      `/vl_avaliacaocredito/${self.dados.leilao_id}/${self.dados.lote_id}`
    ).on('value', function (vl_avaliacao_data) {
      var data = vl_avaliacao_data.val()
      if (data != undefined) {
        self.vl_avaliacaocredito = data.vl_credito
      }
    });

    this.$parent.$on('update-interesse', this.handleInteresseUpdate);
  },

  beforeDestroy() {
    this.$parent.$off('update-interesse', this.handleInteresseUpdate);
  },

  computed: {
    favoritoTitle() {
      return this.isLoteFavorito(this.dados.lote_id) ? 'Remover dos favoritos' : 'Adicionar aos favoritos';
    }
  },

  watch: {
    $route(route) {
      this.refreshLote()
    },
    'dados.statuslote'(novo, ant) {
      if (novo !== ant) {
        (novo && novo === 'status') ? this.loading = true : this.loading = false
        this.refreshLote()
      }
    },
    'dados.vl_lance'(novo, ant) {
      if (novo !== ant) this.refreshLote()
    }
  },

  methods: {
    refreshLote() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      //Atualiza cronometro do lote;
      db.ref(`/dtfechamento/${self.dados.leilao_id}/${self.dados.lote_id}`)
        .on("value", function (data) {
            if (data.val()) {
              self.fechamento = data.val();
              self.dt_fechamento_lote = self.fechamento.dt_fechamento;
            }
          }
        );
    },
    isLoteFavorito(loteId) {
      return this.interesse.some(item => item.lote_id === loteId);
    },

    handleInteresseUpdate(novoInteresse) {
      this.interesse = novoInteresse || [];
    },

    liberacaoExtraMsg(descricao) {
      this.info = descricao;
    },

    fechaModalLiberacaoExtra(valor) {
      this.abreModal = valor
    },

    isNumber: function (evt) {
      evt = evt || window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    addFavorito() {
      const hostName = location.protocol + '//' + window.HOSTNAME;
      const urlRequest = this.isLoteFavorito(this.dados.lote_id) ? 'exclui-favorito' : 'add-favorito';
      const url = new URL(`${hostName}/leilao/${urlRequest}`);

      url.searchParams.append('lote_id', this.dados.lote_id);
      url.searchParams.append('usuario_id', this.usuarioid);

      fetch(url, {method: 'GET'})
        .then((res) => {
          if (!res.ok) {
            return res.json().then((errorData) => {
              console.error('Erro na API:', errorData.message || res.statusText);
              throw new Error(`API Error: ${errorData.message || res.statusText}`);
            });
          }
          return res.json();
        })
        .then((response) => {
          if (response.msg === 'Este lote possui lance(s) e não pode ser removido dos favoritos') {
            alert(response.msg);
            return;
          }

          this.$emit('update-interesse');

          alert(response.msg);

          this.$emit('favoritoModificado', this);
          this.$parent.$emit('favoritoModificado', this);
          this.$parent.$parent.$emit('favoritoModificado', this);
        })
        .catch((error) => {
          console.error('Erro ao modificar favorito:', error);
        });
    },

    enviarVendadireta(ev) {
      var is_lance = false
      const elem = ev.currentTarget

      if (
        elem.getAttribute('disabled') == true ||
        elem.getAttribute('disabled') == 'disabled'
      ) {
        // VERIFICA STATUS DE LIBERADO, CASO TRUE A FUNCAO ACABA AQUI
        return false
      }

      const nm_valor = elem.getAttribute('datavalor')
      const valor = elem
        .getAttribute('datavalor')
        .replace(/\./g, '')
        .replace('R$ ', '')
        .replace(',', '.')
      const loteId = elem.getAttribute('dataloteid')
      const self = this

      this.firebase_db.ref(`/lance/${self.dados.leilao_id}/${loteId}`)
        .orderByChild('id')
        .limitToLast(1)
        .once('value')
        .then(function (data) {
          var usuario_id_logado = self.usuarioid
          if (data.val()) {
            var usuario_id_ultimolance = Object.values(data.val())[0]
              .nm_usuario_id
          } else {
            var usuario_id_ultimolance = null
          }

          if (usuario_id_logado == usuario_id_ultimolance) {
            eventParcelamento()
            var elemParcelas = parcelamento(self)

            self.$modal.show('dialog', {
              title: `<strong style="font-size:20px;color: #512925;">Lote ${self.dados.nu}</strong>`,
              text: ` <p style="color: red;"><strong>VOCÊ JÁ TEM O MAIOR LANCE DESTE LOTE, DESEJA COBRIR O PRÓPRIO LANCE?</strong></p>
                                <p>${self.dados.nm_titulo}</p>
                                ${elemParcelas}
                                <p style="display: flex; align-items: center; gap: 20px; font-size: 16px; font-weight: 600"> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;"> ${self.dados.vl_lance_sugerido}</strong> </p>`,
              buttons: [
                {
                  title: 'NÃO',
                  handler: () => {
                    self.loading = false
                    self.$modal.hide('dialog')
                  }
                },
                {
                  title: 'SIM',
                  default: true, // HABILITAR BOTÃO ENTER
                  handler: () => {
                    self.$modal.hide('dialog')
                    var parcela = document.querySelector('#limite_parcelas option:checked').value
                    modalEnviaLance(
                      self,
                      loteId,
                      valor,
                      nm_valor,
                      is_lance,
                      'Lote',
                      null,
                      null,
                      parcela
                    )
                  }
                }
              ]
            })
          } else {
            modalEnviaLance(
              self,
              loteId,
              valor,
              nm_valor,
              is_lance,
              'Lote',
              null,
              null,
              null
            )
          }
        })
    },

    enviarLance(ev, pl) {
      const elem = ev.currentTarget
      const loteId = elem.getAttribute('dataloteid');

      const numeroDeLinks = document.querySelectorAll(`a[href*='/leilao/index/leilao_id/${this.dados.leilao_id}/lote/${loteId}']`).length;
      const leiloesProibidos = [7078, 7240];

      //Efetua o bloqueio para os leiloes especificos && Do tipo de parcelamento 5 TRT-RibeirãoPreto.
      if ((leiloesProibidos.includes(this.dados.leilao_id) || this.dados.nu_intervaloparcelaslote == 5) && numeroDeLinks < 7) {
        this.$modal.show('dialog', {
          title: `<strong style="font-size:20px;color: #512925;">ATENÇÃO!</strong>`,
          text: ` <p style="color: red;"><strong>Para este leilão, os lances serão aceitos somente dentro da página do lote ou pela opção "Seguir o Leiloeiro". Agradecemos sua compreensão</strong> </p>`,
          buttons: [
            {
              title: 'Fechar',
              handler: () => {
                this.loading = false
                this.$modal.hide('dialog')
              }
            }
          ]
        })

        console.log('Bloq.');
        return false;
      }

      if (!this.dados.liberado || !!!this.usuarioid) {
        return false
      }

      var is_lance = true

      if (
        elem.getAttribute('disabled') == true ||
        elem.getAttribute('disabled') == 'disabled'
      ) {
        // VERIFICA STATUS DE LIBERADO, CASO TRUE A FUNCAO ACABA AQUI
        return false
      }

      var valor = 0
      var titulo = 'Lote'
      if (elem.getAttribute('datavalor') == 0) {
        valor = document.querySelector('#enviar_lance_manual_val_' + loteId)
          .value
        var nm_valor = valor + ' % de desconto'
        valor = valor
          .replace(/\./g, '')
          .replace('R$ ', '')
          .replace(',', '.')
        if (valor > 100) {
          alert('Valor maior que o permitido de 100%')
          return false
        }
        titulo = 'Rodada'
      } else {
        var nm_valor = elem.getAttribute('datavalor')
        valor = elem
          .getAttribute('datavalor')
          .replace(/\./g, '')
          .replace('R$ ', '')
          .replace(',', '.')
      }

      const self = this

      this.firebase_db.ref(`/lance/${self.dados.leilao_id}/${loteId}`)
        .orderByChild('id')
        .limitToLast(1)
        .once('value')
        .then(function (data) {
          if (data.val()) {
            // console.log(data);
            var usuario_id_ultimolance = Object.values(data.val())[0]
              .nm_usuario_id
          } else {
            var usuario_id_ultimolance = null
          }

          var nm_intermediado = null
          var usuario_id_logado = null
          var usuario_id_intermediado = null

          if (self.intermediarios != null) {
            nm_intermediado = document.querySelector(
              '#cmb_usuario_intermediario_' + loteId
            ).selectedOptions[0].text
            usuario_id_intermediado = document.querySelector(
              '#cmb_usuario_intermediario_' + loteId
            ).value
            usuario_id_logado = usuario_id_intermediado
          } else {
            usuario_id_logado = self.usuarioid
          }

          if (usuario_id_logado == usuario_id_ultimolance) {

            if (self.dados.bn_aceitelanceparceladolote === true) {
              eventParcelamento();
              var elemParcelas = (!pl) ? parcelamento(self) : ''
            }

            const percentEntrada = self.dados.nu_limitepercentuallote;

            const condicoesPagamento = `
            <div style="background-color: #f5f5f5; padding: 15px; border-radius: 10px; margin: 10px 0; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);">
              <span style="color: #512925; font-size: 16px; font-weight: 600;">Condições de pagamento:</span><br>
              ${self.dados.bn_aceitelanceparceladolote
              ? `
                ${percentEntrada > 0 ? `<p style="margin: 5px 0;"><strong>Entrada: ${percentEntrada}%</strong></p>` : ''}
                <p style="margin: 5px 0;"><strong>${pl > 1 ? `Parcelamento: ${pl}x` : `Pagamento: à vista ou parcelado em até ${self.dados.nu_limiteparcelaslote}x`}</strong></p>
                ${elemParcelas}
              `
              : `
                <p style="margin: 5px 0;"><strong>Pagamento: à vista</strong></p>
              `}
            </div>`;

            self.$modal.show('dialog', {
              title: `<strong style="font-size:20px;color: #512925;">Lote ${self.dados.nu}</strong>`,
              text: ` <p style="color: red;"><strong>VOCÊ JÁ TEM O MAIOR LANCE DESTE LOTE, DESEJA COBRIR O PRÓPRIO LANCE?</strong></p>
                                <p>${self.dados.nm_titulo}</p>
                                ${condicoesPagamento}
                                <p style="display: flex; align-items: center; gap: 20px; font-size: 16px; font-weight: 600"> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;"> ${nm_valor}</strong> </p>`,
              buttons: [
                {
                  title: 'NÃO',
                  handler: () => {
                    self.loading = false;
                    self.$modal.hide('dialog');
                  }
                },
                {
                  title: 'SIM',
                  default: true, // HABILITAR BOTÃO ENTER
                  handler: () => {
                    self.$modal.hide('dialog');
                    let parcela = 1;

                    // Somente tenta buscar o valor da parcela se o lote aceitar lance parcelado
                    if (self.dados.bn_aceitelanceparceladolote === true) {
                      let selectedOption = document.querySelector('#limite_parcelas option:checked');
                      if (selectedOption) {
                        parcela = selectedOption.value;
                      }
                    }

                    modalEnviaLance(
                      self,
                      loteId,
                      valor,
                      nm_valor,
                      is_lance,
                      'Lote',
                      null,
                      null,
                      parcela
                    );
                  }
                }
              ]
            });
          } else {
            modalEnviaLance(
              self,
              loteId,
              valor,
              nm_valor,
              is_lance,
              'Lote',
              null,
              null,
              null
            );
          }

        })
    },

    loteClicado() {
      this.$parent.$emit('loteIdAtualChange', this.dados.lote_id)
    },

    formatStatusCredito(statuslote) {
      var nm_statuslote = ''
      switch (statuslote) {
        case 'Aberto para Lances':
          nm_statuslote = 'Aguarde'
          break
        case 'Vendido':
        case 'Não Vendido':
          nm_statuslote = 'Encerrado'
          // expected output: "Mangoes and papayas are $2.79 a pound."
          break
        default:
          nm_statuslote = statuslote
      }
      return nm_statuslote
    }
  }
}

function parcelamento(self) {
  var parcelamento = self.$root.refreshParcelamento(self.dados);
  var elemParcelas = `<label style="${(!self.dados.nu_limiteparcelaslote) ? 'display: none;' : ''}"> Parcelas`;

  elemParcelas += `<select id="limite_parcelas" onchange="window.eventParcelas()" style="width: fit-content; margin-left: 5px">`;

  if (self.dados.nu_limiteparcelaslote) {
    for (let index = 1; index <= parcelamento; index++) {
      var text = (index === 1) ? 'à vista' : `${index}x`;
      elemParcelas += `<option value="${index}" ${(index == 1) ? 'selected' : ''}>${text}</option>`;
    }
  } else {
    elemParcelas += `<option value="1" selected>à vista</option>`;
  }

  elemParcelas += `</select></label>`;

  return elemParcelas;
}

function eventParcelamento() {
  window.eventParcelas = () => {
    var parcelaSelecionada = document.querySelector('#limite_parcelas option:checked')

    if (parcelaSelecionada) {
      var limite_parcelas = parcelaSelecionada.value
      var elem = document.querySelector('#limite_parcelas_porcentagem')

      if (limite_parcelas > '1' && elem) {
        elem.style.display = 'block'
      } else if (elem) {
        elem.style.display = 'none'
      }
    }
  }
}

function modalEnviaLance(
  self,
  loteId,
  valor,
  nm_valor,
  is_lance,
  titulo,
  usuario_id_intermediado,
  nm_intermediado,
  pl
) {
  var nm_descricao = '<p>Confirmar o envio de lance?</p>';

  if (is_lance == false) {
    nm_descricao = '<p>Confirmar a venda direta ?</p>';
  }

  if (usuario_id_intermediado != null) {
    nm_descricao = `<p>Confirmar o envio de lance para o usuário <b style="color: red;">${nm_intermediado}</b>?</p>`;
  }

  eventParcelamento();

  let elemParcelas = '';

  if (self.dados.bn_aceitelanceparceladolote === true) {
    elemParcelas = (!pl) ? parcelamento(self) : '';
  }

  const percentEntrada = self.dados.nu_limitepercentuallote;

  const condicaoPagamento = `
  <div style="background-color: #f5f5f5; padding: 15px; border-radius: 10px; margin: 10px 0; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);">
    <span style="color: #512925; font-size: 16px; font-weight: 600;">Condições de pagamento:</span><br>
    ${self.dados.bn_aceitelanceparceladolote
    ? `
      ${percentEntrada > 0 ? `<p style="margin: 5px 0;"><strong>Entrada: ${percentEntrada}%</strong></p>` : ''}
      <p style="margin: 5px 0;"><strong>${pl > 1 ? `Parcelamento: ${pl}x` : `Pagamento: à vista ou parcelado em até ${self.dados.nu_limiteparcelaslote}x`}</strong></p>
      ${elemParcelas}
    `
    : `
      <p style="margin: 5px 0;"><strong>Pagamento: à vista</strong></p>
    `}
  </div>`;

  const domainParts = window.location.hostname.split('.');
  let mainDomain = '';

  if ((domainParts[0] === 'dev' || domainParts[0] === 'teste') && domainParts[1] !== 'vue') {
    mainDomain = domainParts[1];
  } else if (domainParts[0] === 'dev' && domainParts[1] === 'vue') {
    mainDomain = domainParts[2];
  } else if (domainParts[0] === 'www') {
    mainDomain = domainParts[1];
  } else {
    mainDomain = domainParts[0];
  }

  let leiloeiroSelect = '';

  if (mainDomain === 'sobrasdosleiloesdeimoveis') {
    let loteId = self.dados && self.dados.lote_id ? self.dados.lote_id : '';
    let leiloeiroSalvo = sessionStorage.getItem(`leiloeiroSelecionado_${loteId}`) || '';

    leiloeiroSelect = `<select id="select_leiloeiro_${loteId}" style="width:100%;padding:8px;margin-top:10px;">` +
      '<option value="">Selecionar o leiloeiro</option>';

    const leiloeirosVinculados = self.dadosLeilao && self.dadosLeilao.leiloeirovinculado ? self.dadosLeilao.leiloeirovinculado : [];

    leiloeirosVinculados.forEach(leiloeiro => {
      let selected = (leiloeiro.leiloeiro_id === Number(leiloeiroSalvo)) ? 'selected' : '';
      leiloeiroSelect += `<option value="${leiloeiro.leiloeiro_id}" ${selected}>${leiloeiro.nm_leiloeiro}</option>`;
    });

    leiloeiroSelect += '</select>';

    setTimeout(() => {
      const selectElement = document.getElementById(`select_leiloeiro_${loteId}`);
      if (selectElement) {
        selectElement.addEventListener('change', function () {
          sessionStorage.setItem(`leiloeiroSelecionado_${loteId}`, this.value);
        });
      }
    }, 100);
  }

  // Exibição do modal
  self.$modal.show('dialog', {
    title: `<strong style="font-size:20px;color: #512925;">${titulo} ${self.dados.nu}</strong>`,
    text: `<p style="color: #512925;"><strong>${self.dados.nm_titulo}</strong></p>
               ${nm_descricao}
               ${condicaoPagamento}
               ${leiloeiroSelect}
               <p style="display: flex; align-items: center; gap: 20px; font-size: 16px; font-weight: 600"> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;">${nm_valor}</strong> </p>`,
    buttons: [
      {
        title: 'Cancelar',
        handler: () => {
          self.loading = false;
          self.$modal.hide('dialog');
        }
      },
      {
        title: 'Enviar',
        default: true, // HABILITAR BOTÃO ENTER
        handler: () => {
          const loteId = self.dados && self.dados.lote_id ? self.dados.lote_id : '';
          const leiloeiroSelectElement = document.getElementById(`select_leiloeiro_${loteId}`);
          let leiloeiroId = '';

          if (leiloeiroSelectElement) {
            leiloeiroId = leiloeiroSelectElement.value;
            if (!leiloeiroId) {
              alert('Por favor, selecione um leiloeiro antes de enviar o lance.');
              self.loading = false;
              return;
            }
            sessionStorage.setItem(`leiloeiroSelecionado_${loteId}`, leiloeiroId);
          }

          self.loading = true;
          var parcelas = 1;
          if (!pl) {
            var selectedOption = document.querySelector('#limite_parcelas option:checked');
            if (selectedOption) {
              parcelas = selectedOption.value;
            }
          } else {
            parcelas = pl;
          }
          var urlParcelas = (parcelas > 1) ? '&nu_parcelas=' + parcelas : '&nu_parcelas=' + 1;

          var url_post = `${self.pathName}/leilao/envialance/?ajax=1&leilao_id=${self.dados.leilao_id}&lote_id=${loteId}&vl_lance=${valor}&force=0${urlParcelas}&firebase=1`;

          if (leiloeiroId) {
            url_post += `&leiloeiro_id=${leiloeiroId}`;
          }

          if (usuario_id_intermediado != null) {
            url_post += `&usuario_id_intermediado=${usuario_id_intermediado}`;
          }

          fetch(url_post, {method: 'POST'})
            .then((res) => {
              if (!res.ok) {
                throw new Error(`HTTP error! Status: ${res.status}`);
              }
              return res.json();
            })
            .then(res => {
              if (res.erro == true) {
                self.errors.push(res);
                alert(self.$root.decodeHtml(res.msg_erro));
              }
              // Tracking google analytics envio de lance
              ga('send', 'event', 'lance', 'enviado');

              // FECHA MODAL E PARA O LOADING
              self.loading = false;
              self.$modal.hide('dialog');
            })
            .catch(e => {
              self.errors.push(e);
              self.loading = false;
              self.$modal.hide('dialog');
              self.$emit('refresh-dados-gerais');
            });
        }
      }
    ]
  });
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Card.vue